<template>
    <div class="page m-trainPlan">
        <el-form class="page-query" :model="formSearch" :inline="true" size="mini">
            <el-form-item :label="$t('train.name')">
                <el-input v-model="formSearch.name" :placeholder="$t('tip.name')"
                          @keyup.enter.native="getTrainData(1)" clearable></el-input>
            </el-form-item>
            <el-form-item label="培训专题" prop="special">
                <el-select v-model="formSearch.special" collapse-tags placeholder="请选择" clearable>
                    <el-option :label="item.value" :value="item.id" v-for="item in trainSpecialMenu" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <select-multiple :nameArrays="selectNames"
                             v-on:getTrainTypeVal="getTrainTypeVal"
                             v-on:getTrainModeVal="getTrainModeVal"
                             v-on:getExamFormVal="getExamFormVal"
                             v-on:getForLevelVal="getForLevelVal">
            </select-multiple>
            <select-multi-orgs v-model="formSearch.orgIds"></select-multi-orgs>
            <el-form-item :label="$t('train.time')">
                <advanced-date-picker v-model="formSearch.time" selector="select"></advanced-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary"  @click="getTrainData(1)" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>

        <div class="page-table">
            <div class="page-operate">
                <div class="operate-left">
                    <el-button size="small" @click="$router.push({name: 'addTrainPlan'})" type="primary">
                        <i class="nucfont inuc-online"></i> {{$t('train.addOnlineTrain')}}
                    </el-button>

                    <el-button size="small" @click="$router.push({name: 'addOfflinePlan'})">
                        <i class="nucfont inuc-offline"></i> {{$t('train.addOfflineTrain')}}
                    </el-button>

                    <el-tooltip v-if="isDeleteShow" class="item" effect="dark" :content="$t('c.delete')" placement="top-end"
                                :hide-after="1000">
                        <el-button size="small" :title="$t('c.delete')" @click="deletePlan">
                            <i class="nucfont inuc-delete"></i>
                        </el-button>
                    </el-tooltip>
                </div>

                <div class="operate-right">
                    <el-radio-group class="operate-creator" v-model="formSearch.isOnlyMine" @change="getTrainData(1)" size="small">
                        <el-radio-button :label="false">全部</el-radio-button>
                        <el-radio-button :label="true">我的</el-radio-button>
                    </el-radio-group>
                    <el-button-group>
                        <el-tooltip class="item" effect="dark" :content="$t('train.enlarge')" placement="top-start">
                            <el-button size="small" @click="toggleForm">
                                <i class="nucfont" :class="formShow ? 'inuc-arrow-up': 'inuc-arrow-down'"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip v-if="$i18n.locale === 'zh-CN'" class="item" effect="dark" content="表格设置" placement="top-start">
                            <el-button size="small" @click="trainDrawerShow = true">
                                <i class="nucfont inuc-fenlei"></i>
                            </el-button>
                        </el-tooltip>
                    </el-button-group>
                </div>
            </div>

            <data-tables class="form-table"
                         ref="trainTable"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                         @selection-change="handleSelectionChange"
            >
                <!-- column checkbox -->
                <el-table-column type="selection" width="55px" :reserve-selection="true" align="center"
                                 :selectable='checkboxInit'></el-table-column>

                <!-- column title -->
                <el-table-column property="name" :label="$t('train.name')" align="left"
                                 min-width="240px" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.kind" style="float: left;">
                            <i class="nucfont inuc-dingwei" style="color: #999;"></i>
                        </span>
                        {{scope.row.name}}
                    </template>
                </el-table-column>

                <el-table-column v-for="(title, index) in titles" :prop="title.prop" :label="title.label"
                                 :key="index"
                                 align="center"
                                 :width="title.width"
                                 :min-width="title.minWidth"
                                 show-overflow-tooltip
                                 :sortable="title.sortable">
                    <template v-if="title.prop==='percent'" #default="{row}">
                        <span class="progress">
                            {{row.percent == null ? '-' : (Math.round(row.percent * 10000) / 100 + "%")}}
                        </span>
                    </template>
                </el-table-column>

                <!-- column buttons -->
                <el-table-column :label="$t('c.operation')" align="center" width="150px">
                    <template v-slot="{row}">
                        <div class="btn-cell">
                            <i class="nucfont inuc-preview"
                               :title="$t('c.view')"
                               @click="viewTrainPlan(row)"></i>

                            <!-- 未发布：编辑、关联、发布 -->
                            <span v-permission="[1, row.creatorID]" v-if="!row.isPublish">
                                <i :title="$t('c.edit')"
                                   class="nucfont inuc-edit"
                                   @click="editTrainPlan(row)">
                                </i>
                                <i :title="$t('c.publish')"
                                   class="nucfont inuc-publish"
                                   @click="handlePublish(row.id)">
                                </i>
                            </span>

                            <!-- 已发布：二维码（线上）、延长、推送  -->
                            <span v-permission="[1, row.creatorID]" v-if="row.isPublish">
                                <i v-if="!row.kind"
                                   :title="$t('train.qrCode')"
                                   class="nucfont inuc-erweima"
                                   @click="createQRCode(row)">
                                </i>
                                <i :title="$t('train.extendEndTime')"
                                   class="nucfont inuc-clock-o"
                                   @click="extendEndTime(row)">
                                </i>
                                <i :title="$t('train.pushMessage')"
                                   class="nucfont inuc-xiaoxituisong"
                                   @click="handlePush(row.id)">
                                </i>
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </data-tables>
        </div>

        <!-- 扫码加入培训计划 -->
        <QRCodeDialog v-model="qrDialog" :data="currentData" />

        <!-- 延长计划时间 -->
        <extend-time-dialog
            v-model="extendDialog"
            :data="currentData"
            @success="getTrainData"
        ></extend-time-dialog>

        <train-drawer :show.sync="trainDrawerShow"></train-drawer>

        <transition enter-active-class="animated zoomIn"
                    leave-active-class="animated zoomOutUp">
            <router-view @onClose="onSubpageClose"></router-view>
        </transition>
    </div>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';
    import {mapGetters} from 'vuex'
    import SelectMultiple from '@/components/Selectmultiple.vue';
    import SelectSingleOrg from '@/components/SelectSingleOrg.vue'
    import TrainDrawer from "./Components/TrainDrawer"
    import QRCodeDialog from "./Components/QRCodeDialog";
    import ExtendTimeDialog from "./Components/ExtendTimeDialog"
    import AdvancedDatePicker from '@/components/DatePickerAdvanced'

    export default {
        name: 'trainPlan',
        components: {
            SelectMultiple,
            SelectSingleOrg,
            TrainDrawer,
            QRCodeDialog,
            ExtendTimeDialog,
            AdvancedDatePicker
        },
        data() {
            return {
                userInfo: {},
                //删除相关
                isDeleteShow: false,
                //搜索条件相关
                formSearch: {
                    name: '',
                    special: '',
                    types: [],
                    kinds: [],
                    forms: [],
                    forlevels: [],
                    time: {},
                    orgIds: [],
                    startTime: '',
                    endTime: '',
                    isOnlyMine: false
                },
                allTitles: [
                    {
                        prop: 'specialName',
                        label: '培训专题'
                    },
                    {
                        prop: 'typeName',
                        label: this.$t('train.type')
                    },
                    {
                        prop: 'formName',
                        label: this.$t('c.examType')
                    },
                    {
                        prop: 'forLevelName',
                        label: this.$t('c.operatorLevel')
                    },
                    {
                        prop: 'duration',
                        label: this.$t('c.date'),
                        minWidth: '240px',
                        sortable: 'custom'
                    },
                    {
                        prop: 'hours',
                        label: this.$t('train.hour'),
                        sortable: 'custom'
                    },
                    {
                        prop: 'credit',
                        label: this.$t('train.credit'),
                        sortable: 'custom'
                    },
                    {
                        prop: 'percent',
                        label: this.$t('train.percent'),
                        sortable: 'custom'
                    },
                    {
                        prop: 'creatorName',
                        label: this.$t('c.creator')
                    },
                ],
                formShow: true,
                tableData: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto",
                },
                currentPage: 1,
                selectNames: [{
                    key: "trainType",
                }, {
                    key: "trainMode",
                }, {
                    key: "examForm",
                }, {
                    key: "forLevel",
                }],
                selectPlanId: [],
                trainDrawerShow: false,

                extendDialog: false,
                currentData: {},

                qrDialog: false,
            }
        },

        created() {
            if (Ticket.get()) {
                this.userInfo = Ticket.get();
            }

            this.getTrainData();

            this.$store.commit('initUserTrainSetting')
            this.$store.dispatch('getTrainSpecialMenu')
        },

        computed: {
            titles() {
                let columns = this.$store.getters.userTrainSetting.columns

                if (!columns) {
                    return this.allTitles
                }

                let titles = this.allTitles.filter(item => !!columns.includes(item.prop))

                return titles
            },
            ...mapGetters([
                'trainSpecialMenu',
            ]),
        },
        methods: {
            getTrainData(page) {
                if(page) this.currentPage = page;
                let queryData = {
                    ...this.formSearch,
                    startTime: this.formSearch.time[0],
                    endTime: this.formSearch.time[1],
                };

                delete queryData.time;

                ['types', 'forms', 'forlevels'].forEach(v => {
                    if (this.formSearch[v].includes(0)) {
                        delete queryData[v];
                    }
                });

                if (!queryData.special) {
                    delete queryData.special
                }

                if (queryData.kinds.indexOf(0) > -1) {
                    delete queryData.kinds
                } else if (queryData.kinds.length && queryData.kinds.indexOf(0) < 0) {
                    queryData.kinds = queryData.kinds.map(v => v-1)
                }

                api.getTraining(queryData).then(res => {
                    let data = res.package;

                    for (let i = 0; i < data.length; i++) {
                        data[i].duration = data[i].startTime.substring(0, 10) + " — "
                            + (data[i].endTime && data[i].endTime || '');
                        data[i].prePublishTime = data[i].prePublishTime?data[i].prePublishTime:'-';
                    }

                    this.tableData = data;

                    this.$nextTick(() => {
                        let elTable = this.$refs.trainTable?.$refs?.elTable
                        elTable && elTable.doLayout()
                    })
                })
            },
            handlePublish(id) {
                this.$confirm(this.$t('m.publish'), this.$t('c.publish'), {
                    type: 'warning'
                }).then(() => {
                    api.publishTraining(id).then((data) => {
                        this.getTrainData();
                    });
                }).catch(() => {});
            },
            handlePush(id) {
                this.$confirm(this.$t('train.surePushMessage'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    api.pushMessage(id).then((data) => {
                        this.$message({
                                type: 'success',
                                message: this.$t('train.pushSuccess')
                            });
                        this.getTrainData();
                    });
                }).catch(() => {});
            },
            deletePlan() {
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    if (this.selectPlanId.length == 1) {
                        api.deleteTraining(this.selectPlanId).then((data) => {
                            this.$message({
                                type: 'success',
                                message: this.$t('m.delSuccess')
                            });
                            this.getTrainData();
                            this.isDeleteShow = false;
                            this.$refs.trainTable.$refs.elTable.clearSelection();
                        });
                    } else {
                        api.deleteBatchTraining({ids: this.selectPlanId}).then((data) => {
                            this.$message({
                                type: 'success',
                                message: this.$t('m.delSuccess')
                            });
                            this.getTrainData();
                            this.isDeleteShow = false;
                            this.$refs.trainTable.$refs.elTable.clearSelection();
                        });
                    }
                }).catch(() => {
                });
            },
            handleSelectionChange(val) {
                this.selectPlanId = [];
                val.forEach((v, k) => {
                    this.selectPlanId.push(v.id);
                });
                this.selectPlanId.length ? this.isDeleteShow = true : this.isDeleteShow = false;
            },
            checkboxInit(row) {
                return (this.userInfo.type===1) || (row.creatorID === this.userInfo.userID);
            },
            //搜索赋值
            getTrainTypeVal(data) {
                this.formSearch.types = data;
            },
            getTrainModeVal(data) {
                this.formSearch.kinds = data;
            },
            getExamFormVal(data) {
                this.formSearch.forms = data;
            },
            getForLevelVal(data) {
                this.formSearch.forlevels = data;
            },

            viewTrainPlan(data) {
                if (data.kind === 0) {
                    this.$router.push({name: 'trainPlanDetail',params: {planId: data.id}})
                } else if (data.kind === 1) {
                    this.$router.push({name: 'offlinePlanDetail',params: {planId: data.id}})
                }
            },
            editTrainPlan(data) {
                // kind: 0线上 1线下
                if (data.kind === 0) {
                    this.$router.push({name: 'editTrainPlan',params: {planId: data.id}})
                } else if (data.kind === 1) {
                    this.$router.push({name: 'editOfflinePlan',params: {planId: data.id}})
                }
            },

            createQRCode(data) {
                this.currentData = {...data}
                this.$store.dispatch('getOrgTree');
                this.qrDialog = true;
            },

            //延迟结束时间
            extendEndTime(data){
                this.currentData = {...data}
                this.extendDialog = true
            },

            toggleForm() {
                let $form = $('.page-query');

                if (this.formShow) {
                    $form.slideUp();
                } else {
                    $form.slideDown();
                }
                this.formShow = !this.formShow;
            },

            onSubpageClose() {
                if (Ticket.get()) this.getTrainData()
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    .form-table {
        overflow: hidden;
    }

    .page-query {
        margin-bottom: 0;
        padding-bottom: 0;
    }

    .page-table {
        box-shadow: none;
        overflow: hidden;
        .page-operate {
            display: flex;
            justify-content: space-between;
            button {
                width: auto;
            }
            .nucfont {
                margin-right: 3px;
                font-size: 14px;
            }
        }

        .operate-creator {
            margin-right: 10px;
        }
    }

    .progress {
        display: inline-block;
        width: 60px;
        background-color: #2FC0A1;
        color: #fff;
        text-align: center;
        border-radius: 10px;
    }
</style>
